import { render } from "./test1.vue?vue&type=template&id=ecd23886"
import script from "./test1.vue?vue&type=script&lang=js"
export * from "./test1.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/other/dynamicSegment/test1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ecd23886"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ecd23886', __exports__)) {
    console.log('reload')
    api.reload('ecd23886', __exports__)
  }
  
  module.hot.accept("./test1.vue?vue&type=template&id=ecd23886", () => {
    console.log('re-render')
    api.rerender('ecd23886', render)
  })

}


export default __exports__